import React, { Component } from 'react';
import {
    Redirect,
    Link,
    withRouter
} from "react-router-dom";
import Cookies from 'universal-cookie';
import * as Constant from '../Constant';
import Axios from 'axios';
import Modal from 'react-modal';
import { Home, FileText, PhoneCall, Book, Menu, User, LogIn, LogOut, List, UserPlus, AlignCenter, AlignJustify } from 'react-feather'

Modal.setAppElement('#root');

const cookies = new Cookies();

class NewHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            gone: '',
            go_profile: false,
            go_notif: false,
            isSidebarOpen: false, // Tambahkan state untuk sidebar
        };
    }

    // componentDidMount() {
    //     this.goBack = this.goBack.bind(this);
    //     this.ifLogin();
    // }

    goBack() {
        this.props.history.goBack();
    }



    // ifLogin() {
    //     if (cookies.get('user_id') != null) {
    //         document.getElementById('login').hidden = true;
    //         Axios.get(Constant.GET_USER, {
    //             headers: {
    //                 'Authorization': cookies.get('accessToken'),
    //             },
    //         }).then(response => {
    //             this.setState({ id: response.data.id });
    //         }).catch(error => {
    //             console.log(error);
    //         });
    //     } else {
    //         this.setState({ gone: "hidden" });
    //     }
    // }

    toggleSidebar = () => {
        this.setState({ isSidebarOpen: !this.state.isSidebarOpen });
    };

    render() {
        const {
            id, gone, go_profile, go_notif, isSidebarOpen
        } = this.state;

        let image_link = '';
        let back_url = '';

        if (cookies.get('user_id') != null) {
            image_link = Constant.GET_PROFILE_PICTURE + id;
        }

        if (go_profile) return <Redirect exact to="/profile" />;
        if (go_notif) return <Redirect exact to="/notification" />;
        if (this.props.back_url != null) back_url = this.props.back_url;

        // CSS in JS
        const styles = {
            pageTitleLarge: {
                backgroundColor: '#EA6022',
                color: 'white',
                padding: '20px 0',
            },
            headerContainer: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap', // Tambahkan ini untuk fleksibilitas
                padding: '10px 20px',
                position: 'relative',
                maxWidth: '480px',
                margin: '0 auto',
            },
            headerLeft: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
                marginBottom: '10px', // Spasi antar elemen pada wrap
                bottom: '45px',
                left: '0',
                width: '60px',
            },
            headerCenter: {
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                maxWidth: '100%',
            },
            headerCenter: {
                flex: 1, // Membuat elemen ini fleksibel
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                maxWidth: '500px', // Batas maksimal pada layar besar
                minWidth: '200px', // Lebar minimal untuk menghindari tabrakan
                padding: '0 10px', // Tambahkan padding untuk menjaga jarak
            },
            searchContainer: {
                display: 'flex',
                alignItems: 'center',
                marginLeft: '0', // Sesuaikan margin
                backgroundColor: '#fff',
                borderRadius: '50px',
                padding: '8px 15px',
                width: '100%', // Lebar penuh pada layar kecil
                maxWidth: '300px', // Atur max width
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
            },
            searchIcon: {
                marginRight: '10px',
                color: '#AAB2BD',
                fontSize: '18px',
            },
            inputSearch: {
                flex: 1,
                border: 'none',
                outline: 'none',
                borderRadius: '50px',
                width: '100%',
            },
            backButton: {
                position: 'relative',
                left: '0px',
                padding: '10px', // Sesuaikan padding
            },
            logo: {
                height: 'auto',
                maxWidth: '70px', // Perkecil logo pada layar kecil
            },
            pageTitleBg: {
                height: '210px',
                backgroundColor: '#EA6022',
            },
        };


        const customSidebarStyles = {
            content: {
                position: 'fixed',  // Menetapkan posisi tetap agar modal berada di tempat yang tepat
                top: '0px',
                right: '0px',  // Tempatkan di kanan
                left: 'auto',  // Pastikan sisi kiri tidak digunakan
                width: '260px',
                height: '95%', // Sidebar penuh tinggi layar
                overflow: 'auto',
                marginTop: '16px',
                marginBottom: 'auto',
                border: '0px',
                borderRadius: '15px',
                borderTopRightRadius: '0px',
                borderBottomRightRadius: '0px',
                justifyContent: 'center',
                zIndex: 100, // Pastikan z-index cukup tinggi
            },
            overlay: {
                zIndex: 99,
                backgroundColor: 'rgba(0, 0, 0, 0.45)', // Transparansi background overlay
            },
        };
        



        return (
            <div>
                {/* HEADER */}
                <div className="page-title-large color-white" style={styles.pageTitleLarge}>
                    <div style={styles.headerContainer} className="header-container">
                        {/* Left section: Logo */}
                        <div style={styles.headerLeft}>
                            {back_url !== '' &&
                                <Link to={back_url}>
                                    <i id="ic-sidebar" className="fa fa-arrow-left" style={styles.backButton}></i>
                                </Link>
                            }
                            <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
                                <img src="/ywci/logo.png" alt="Logo" style={styles.logo} />
                            </Link>
                        </div>

                        {/* Center section: Search Bar */}
                        <div style={styles.headerCenter}
                            onClick={() => (window.location.href = '/programs')}
                        >

                            <div style={styles.searchContainer}>
                                <i className="fa fa-search" style={styles.searchIcon}></i>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    style={styles.inputSearch}
                                />
                            </div>
                        </div>

                        {/* Right section: Menu Button */}
                        <div style={styles.headerRight}>
                            <button
                                onClick={this.toggleSidebar}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#fff',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                }}
                            >
                                <i className="fa fa-bars"></i>
                            </button>
                        </div>
                    </div>

                </div>

                <div className="page-title-bg dark-mode-tint" style={styles.pageTitleBg}></div>
                <div className="page-title-bg opacity-90 bg-highlight" style={styles.pageTitleBg}></div>

                {/* Sidebar Modal */}
                <Modal
                    isOpen={isSidebarOpen}
                    onRequestClose={this.toggleSidebar}
                    contentLabel="Sidebar"
                    style={customSidebarStyles}
                    closeTimeoutMS={300}
                >
                    <div className="menu-content" style={{ padding: '20px' }}>
                        <h3 style={{ marginBottom: '30px' }}>Menu</h3>
                        <div>
                            <Link to="/tentang-kami" onClick={this.toggleSidebar} style={{ width: '100%' }}>
                                <div className="item-menu" style={{ marginBottom: '10px' }}>
                                    <User stroke="#AAB2BD" size={25} className="ic-menu" style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                                    Tentang Kami
                                </div>
                            </Link>
                            <Link to="/bantuan" onClick={this.toggleSidebar} style={{ width: '100%' }}>
                                <div className="item-menu" style={{ marginBottom: '10px' }}>
                                    <List stroke="#AAB2BD" size={25} className="ic-menu" style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                                    Bantuan
                                </div>
                            </Link>
                            <Link to="/contact-center" onClick={this.toggleSidebar} style={{ width: '100%' }}>
                                <div className="item-menu" style={{ marginBottom: '10px' }}>
                                    <PhoneCall stroke="#AAB2BD" size={25} className="ic-menu" style={{ verticalAlign: 'bottom', marginRight: '10px' }} />
                                    Contact Center
                                </div>
                            </Link>
                        </div>
                    </div>
                </Modal>

            </div>
        );
    }
}

export default withRouter(NewHeader);
